<glxy-select-input
  dense
  required="true"
  [formControl]="daysFormControl"
  [options]="daysOptions"
  [label]="'AUTOMATIONS.EDITOR.FILTERS.USER_DATA.DATA_LABELS.DAYS' | translate"
></glxy-select-input>
